import PubSub from 'vanilla-pubsub'
import projectBase from '../projectBase'
import { wait } from '../utils'

export default class Youtube {
  constructor(selector) {
    this.el = document.querySelectorAll(selector)
    this.container = document.querySelector('[data-youtube]')
    this.iframe = this.container.querySelector('iframe')
    this.isFallback = projectBase.state.browser === 'safari'
    this.state = {
      active: false,
    }

    if (this.el.length) {
      this.initialize()
    }
  }

  initialize() {
    this.onClick = this.onClick.bind(this)
    this.onFullScreenChange = this.onFullScreenChange.bind(this)

    this.bind()
  }

  /**
   * イベントハンドラをバインド
   */
  bind() {
    this.checkFullScreen = this.checkFullScreen.bind(this)
    ;[...this.el].forEach((el) => {
      el.addEventListener('click', this.onClick)
    })

    this.iframe.addEventListener('fullscreenchange', this.onFullScreenChange)
    PubSub.subscribe('Modal.disable', this.checkFullScreen)
  }

  /**
   * トリガークリックハンドラ
   */
  async onClick(e) {
    const target = e.currentTarget
    const id = target.dataset.id
    this.iframe.src = `https://www.youtube.com/embed/${id}`

    if (!this.isFallback) {
      this.container.style.display = 'block'
      await wait(10)
      this.container.classList.add('is-active')

      this.iframe.requestFullscreen()
    } else {
      // fallback対象の場合、Youtubeをモーダルとして表示
      projectBase.modules.modal.active('youtube')
    }

    this.state.active = true
  }

  /**
   * 全画面モードの開始、終了時ハンドラ
   */
  onFullScreenChange(e) {
    const el = e.target
    const isFullScreen = document.fullscreenElement === el

    // 全画面状態から抜けていたら終了処理
    if (!isFullScreen) {
      this.disable()
    }
  }

  /**
   * 全画面モード終了かつ、iframeの初期化処理
   */
  async disable() {
    if (!this.isFallback) {
      this.container.classList.remove('is-active')
      this.container.style.display = ''
    }

    this.iframe.src = ''
    this.state.active = false
  }

  /**
   * フルスクリーン状態の確認
   */
  checkFullScreen() {
    // fallback 対象かつ、モーダル終了時Youtubeがアクティブだった場合
    if (this.isFallback && this.state.active) {
      this.disable()
    }
  }
}
